import { getTimezoneDayjs } from '@/utils/time';

import type { FeedbacksSettingT } from './types';

export const FEEDBACK_GALLERY_DEFAULT_TITLE = 'Feedback Gallery';

export const getFeedbackGalleryTitle = (
  title: string,
  replaceFeedbackTerminology: (text: string) => string,
) =>
  title === FEEDBACK_GALLERY_DEFAULT_TITLE
    ? replaceFeedbackTerminology(title)
    : title;

export const getDefaultFilterSet = () => ({
  start_date: getTimezoneDayjs().subtractVal(12, 'month').toJSON(),
  end_date: getTimezoneDayjs().toJSON(),
} as unknown as StructuredFilter);

export const DEFAULT_FEEDBACKS_SETTING: FeedbacksSettingT = {
  filter_set: getDefaultFilterSet(),
  title: FEEDBACK_GALLERY_DEFAULT_TITLE,
  sort_by: 'date',
  order_by: 'desc',
};

export const GALLERY_MIN_COLUMN_WIDTH = 380;
export const GALLERY_COLUMN_GAP = 20;
export const GALLERY_MAX_COLUMN_COUNT = 4;
